import Script from "next/script"
import {LoadOnAllPages} from "./LoadOnAllPages.js";

const GoogleAnalytics = ({ga_id = "undefined"}) => {
  return (
    <>
      <LoadOnAllPages/>
      <Script
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=G-QS3V0ZQYYS`}
      />
      <Script id="gtagInit" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('set', { 'cookie_flags': 'SameSite=None;Secure' });
          gtag('config', 'G-QS3V0ZQYYS');
        `}
      </Script>
    </>
  );
}

export {GoogleAnalytics};